import Vue from "vue";
import store from "@/store";

import VueRouter from "vue-router";
import Home from "../views/Home.vue";

// ACCOUNT
import Login from "../views/Login.vue";
import Contact from "../views/Contact.vue";
import Register from "../views/Register.vue";
import EditAccount from "../views/EditAccount.vue";

// ORDERS
import OrderForm from "../views/OrderForm.vue";
import OrderReview from "../views/OrderReview.vue";
import OrderApproval from "../views/OrderApproval.vue";

Vue.use(VueRouter);

const routes = [
  // REDIRECTS
  {
    path: "/schedule",
    name: "schedule-redirect"
  },
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },

  {
    path: "/login/reset",
    name: "ResetPassword",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue")
  },
  {
    path: "/editaccount",
    name: "EditAccount",
    component: EditAccount
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  },
  {
    path: "/order",
    name: "createOrder",
    component: OrderForm
  },
  {
    path: "/order-review/:orderId",
    name: "reviewOrder",
    component: OrderReview
  },
  {
    path: "/order/:orderId",
    name: "updateOrder",
    component: OrderForm
  },
  {
    path: "/order/:orderId/approval",
    name: "doctorApproval",
    component: OrderApproval
  }
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async function(to, from, next) {
  if (
    window.location.href.indexOf("mis-implants") > -1 &&
    window.location.protocol != "https:"
  ) {
    location.href = location.href.replace("http://", "https://");
  } else {
    let user = store.state.user || (await store.dispatch("initUser"));
    if (
      to.path.indexOf("/schedule") > -1 &&
      to.query.owner &&
      to.query.calendarID
    ) 
    {
      // External Redirect
      window.location.replace
      (
        `https://app.acuityscheduling.com/schedule.php?owner=${to.query.owner}&calendarID=${to.query.calendarID}`
      );
      // window.open(
      //   `https://app.acuityscheduling.com/schedule.php?owner=${to.query.owner}&calendarID=${to.query.calendarID}`
      // );
      return false;
    }
    if (user) {
      store.dispatch("updateShowTopBar", true);
      if (!to.name || /^(login||register)$/i.test(to.name)) {
        next("/");
      } else {
        next();
      }
    } else {
      if (/^(login||register||ResetPassword)$/i.test(to.name)) {
        next();
      } else {
        store.dispatch("saveRequestedPath", to.path);

        next("/login");
      }
    }
  }
});
export default router;
